import { SEVERITIES, SEVERITY, type Severity } from '@soc/shared';
import { sevColor, sevGlow } from '../../lib/severity';

const LABEL: Record<Severity, string> = {
  CRITICAL: 'CRIT',
  HIGH: 'HIGH',
  MEDIUM: 'MED',
  LOW: 'LOW',
};
const tint = (sev: Severity) => ({ bg: SEVERITY[sev].chip, border: SEVERITY[sev].glow });

export function SeveritySummary({ counts }: { counts: Record<Severity, number> }) {
  return (
    <div style={{ padding: '0 14px 12px', display: 'flex', gap: 8 }}>
      {SEVERITIES.map((sev) => (
        <div
          key={sev}
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            background: tint(sev).bg,
            border: `1px solid ${tint(sev).border}`,
            borderRadius: 8,
            padding: '8px 10px',
          }}
        >
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: sevColor(sev),
              boxShadow: `0 0 7px ${sevGlow(sev)}`,
            }}
          />
          <span className="mono" style={{ fontSize: 17, fontWeight: 600, color: sevColor(sev) }}>
            {counts[sev]}
          </span>
          <span className="eyebrow" style={{ fontSize: 11, color: 'var(--text-muted)', letterSpacing: 1 }}>
            {LABEL[sev]}
          </span>
        </div>
      ))}
    </div>
  );
}
